import * as tslib_1 from "tslib";
import { AfterContentInit, AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, Injector, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges, QueryList, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { uuid, isNullOrEmpty } from '@awp/core/utils';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { combineLatest, forkJoin, of, Subject } from 'rxjs';
import { catchError, debounceTime, delay, map, switchMap, tap, mapTo, startWith, take } from 'rxjs/operators';
import { ContentParser } from '../../content.parser';
import { ContentService } from '../../content.service';
import { ContentOutletDirective } from '../../directives';
import { ContentFragmentProvider } from '../../content-fragment.provider';
var ContentComponent = /** @class */ (function () {
    function ContentComponent(render, injector, contentService, contentParser, fragmentProvider, parser, sanitizer, changeDetectorRef) {
        var _this = this;
        this.render = render;
        this.injector = injector;
        this.contentService = contentService;
        this.contentParser = contentParser;
        this.parser = parser;
        this.sanitizer = sanitizer;
        this.changeDetectorRef = changeDetectorRef;
        this._componentDefs = new Map();
        this._contentChanges$ = new Subject();
        this._fragmentChanges$ = new Subject();
        this._contentOutletChanges$ = new Subject();
        this.startLoading = new EventEmitter();
        this.finishLoading = new EventEmitter();
        this.loading = new EventEmitter();
        combineLatest(this._contentChanges$, this._fragmentChanges$, this._contentOutletChanges$)
            .pipe(tap(function () { return _this.changeDetectorRef.markForCheck(); }), debounceTime(500), tap(function () {
            _this.startLoading.emit();
            _this.loading.emit(true);
        }), switchMap(function () {
            console.log(_this.name + " Combine Latest Notify Changed");
            return _this.notifyOutletChanged()
                .pipe(tap(function () {
                _this.finishLoading.emit();
                _this.loading.emit(false);
            }));
        }), untilDestroyed(this))
            .subscribe(function (p) {
            _this.changeDetectorRef.markForCheck();
        });
        fragmentProvider.fragments
            .pipe(take(1))
            .subscribe(function (fragments) {
            _this._fragments = fragments;
            _this._fragmentChanges$.next();
        });
    }
    ContentComponent.prototype.ngOnInit = function () {
        this.loading.emit(true);
    };
    ContentComponent.prototype.ngOnChanges = function (changes) {
        if (changes.content != null && changes.content.currentValue !== changes.content.previousValue) {
            this._contentChanges$.next();
        }
        if (changes.key != null && changes.key.currentValue !== changes.key.previousValue) {
            this._contentChanges$.next();
        }
    };
    ContentComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.contentOutlets.changes
            .pipe(startWith(this.contentOutlets.toArray()), untilDestroyed(this))
            .subscribe(function (p) {
            _this._contentOutletChanges$.next();
        });
    };
    ContentComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () { return _this.loading.emit(false); }, 500);
    };
    ContentComponent.prototype.ngOnDestroy = function () {
        if (this._componentDefs != null) {
            this._componentDefs.forEach(function (p) { return p.ngOnDestroy(); });
        }
    };
    ContentComponent.prototype.notifyOutletChanged = function () {
        var _this = this;
        var el = this.render.createElement('div');
        return of(el).pipe(switchMap(function (element) {
            if (_this.content != null) {
                element.innerHTML = _this.parser.interpolate(_this.content, _this.params);
            }
            else if (!isNullOrEmpty(_this.key)) {
                return _this.getContentFragment(_this.key)
                    .pipe(tap(function (content) { return element.innerHTML = content; }), mapTo(element));
            }
            return of(element);
        }), switchMap(function (element) {
            var contentElements = _this.getElementByType(element, 'content');
            if (contentElements.size > 0) {
                // Need to fetch content fragments from CMS
                var fragmentKeys_1 = tslib_1.__spread(contentElements.keys());
                return forkJoin(fragmentKeys_1.map(function (p) { return _this.getContentFragment(p); }))
                    .pipe(tap(function (fragments) {
                    fragmentKeys_1.forEach(function (value, index) {
                        var contentFragment = fragments[index];
                        if (contentFragment != null) {
                            var elements = contentElements.get(value);
                            elements.forEach(function (el) { return el.innerHTML = contentFragment; });
                        }
                    });
                }), map(function (fragments) { return element; }));
            }
            else {
                return of(element);
            }
        }), tap(function (element) {
            // Need to clear inner content from data-component as it includes extra markup.
            var componentElements = _this.getElementByType(element, 'component');
            componentElements.forEach(function (elementRefs) {
                elementRefs.forEach(function (el) { return el.innerHTML = ''; });
            });
            //Get all content as text for angular sanitisation before inject it into the page.
            _this.safeContent = _this.sanitizer.bypassSecurityTrustHtml(element.innerHTML); // Todo: Should possible use sanitize method here instead.
            _this.changeDetectorRef.markForCheck();
        }), delay(500), // Need to delay so change detection will run
        tap(function () { return _this.createComponentOutlets(_this.containerContent.nativeElement); }), tap(function () { return _this.createContentOutlets(_this.containerContent.nativeElement); }));
    };
    ContentComponent.prototype.createComponentOutlets = function (elementRef) {
        var _this = this;
        var componentRefs = this.getElementByType(elementRef, 'component');
        var refIds = new Set();
        componentRefs.forEach(function (elements, key) {
            var componentName = _this.getFragment(key, 'component').componentName;
            elements.forEach(function (element) {
                var componentInstance = _this.getInjectedComponent(element);
                if (componentInstance != null) {
                    refIds.add(componentInstance.outletId);
                }
                else if (componentName != null) {
                    element.innerHTML = '';
                    var component = new ContentOutletDirective(_this.injector);
                    component.componentName = componentName;
                    component.outletId = key + ":" + uuid();
                    component.createComponent(element);
                    _this.appendDataElement(element, 'component', component.outletId);
                    _this._componentDefs.set(component.outletId, component);
                    refIds.add(component.outletId);
                }
                else {
                    console.warn("data-component " + key + " not found");
                }
            });
        });
        // Need to remove components that no longer exist in list.
        var removedIds = tslib_1.__spread(this._componentDefs.keys()).filter(function (id) { return !refIds.has(id); });
        removedIds.forEach(function (p) {
            var outlet = _this._componentDefs.get(p);
            outlet.destroyComponent();
            _this._componentDefs.delete(p);
        });
        this.changeDetectorRef.markForCheck();
    };
    ContentComponent.prototype.createContentOutlets = function (elementRef) {
        if (elementRef == null || this.contentOutlets == null || this.contentOutlets.length == 0)
            return;
        var contentElements = this.getElementByType(elementRef, 'content');
        this.contentOutlets.forEach(function (p) {
            var item = contentElements.get(p.outletId);
            if (item != null && item.length > 0) {
                p.createComponent(item[0]);
            }
        });
    };
    ContentComponent.prototype.getFragment = function (id, type) {
        if (this._fragments == null) {
            return {};
        }
        var item = this._fragments[id];
        return item != null && item.type === type ? item : {};
    };
    ContentComponent.prototype.getInjectedComponent = function (elementRef) {
        var id = this.getDataElement(elementRef);
        if (id != null) {
            var componentRef = this._componentDefs.get(id);
            if (componentRef == null) {
                console.warn('Component not found');
            }
            else {
                return componentRef;
            }
        }
        return null;
    };
    ContentComponent.prototype.appendDataElement = function (elementRef, type, id) {
        var componentComment = this.render.createComment("data-" + type + "=\"" + id + "\"");
        elementRef.append(componentComment);
    };
    ContentComponent.prototype.getDataElement = function (elementRef) {
        if (elementRef.childNodes.length > 0) {
            var firstChild = elementRef.childNodes[0];
            if (firstChild.nodeType === 8) { // nodeType 8 is a comment node
                var id = firstChild.nodeValue.substr('data-component='.length).replace(/"/g, '');
                return id;
            }
        }
        return null;
    };
    ContentComponent.prototype.getElementByType = function (elementRef, type) {
        var elements = elementRef.querySelectorAll("div[data-" + type + "]");
        var result = new Map();
        elements.forEach(function (element) {
            var attr = element.attributes.getNamedItem("data-" + type);
            var entry = result.get(attr.value);
            if (entry == null) {
                result.set(attr.value, [element]);
            }
            else {
                entry.push(element);
            }
        });
        return result;
    };
    ContentComponent.prototype.getContentFragment = function (id) {
        var _this = this;
        if (this._fragments == null) {
            return of(null);
        }
        var fragment = this._fragments[id];
        if (fragment != null && fragment.type === 'html') {
            return this.contentService.getContent(fragment.href, null, 'html')
                .pipe(map(function (response) {
                return _this.contentParser.interpolate(response, _this.params);
            }), catchError(function (err) {
                console.error("Error fetching content fragment '" + name + "'");
                return of(null);
            }));
        }
        else {
            return of(null);
        }
    };
    return ContentComponent;
}());
export { ContentComponent };
